module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/punching-d1038d07a625c7ceb6d6f1d682a95baa.png";